import { render, staticRenderFns } from "./DTDescription.vue?vue&type=template&id=932108c8&"
import script from "./DTDescription.vue?vue&type=script&lang=js&"
export * from "./DTDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports